import { ApprovalWorkflowPage } from 'approval-workflow/approvalWorkflowPage';
import { Redirect } from 'react-router-dom';
import { PERMISSIONS } from 'shared/constants';
import { useTitle } from 'shared/hooks';
import { useUserPermissions } from 'shared/hooks/use-user-permissions';
import { ROUTES } from './routes';

export function ApprovalWorkflowPageResolver() {
  const userPermissions = useUserPermissions();

  useTitle('Approval Workflow - American Bath');

  if (!userPermissions.includes(PERMISSIONS['contract.review'])) {
    return <Redirect to={ROUTES.unauthorized} />;
  }
  return <ApprovalWorkflowPage />;
}
